export const navLinks = [
  { id: "overview", label: "作品速览" },
  { id: "characters", label: "人物档案" },
  { id: "story", label: "剧情脉络" },
  { id: "fanworks", label: "同人创作" },
  { id: "doujin", label: "本子与番外" },
  { id: "resources", label: "资源入口" },
  { id: "guide", label: "阅读指南" },
  { id: "updates", label: "更新动态" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { value: "128", suffix: "+", label: "收录条目" },
  { value: "342", suffix: "篇", label: "同人创作" },
  { value: "1,240", suffix: "章", label: "章节索引" },
  { value: "5,600", suffix: "+", label: "读者讨论" },
];

export const heroChips = [
  "漫画正篇",
  "文库小说",
  "同人合集",
  "番外本子",
  "无翼鸟专题",
  "更新日历",
];

export const overviewFeatures = [
  {
    icon: "ri-book-2-line",
    title: "一个页面读完全貌",
    desc: "从题材定位、人物关系到卷章脉络集中呈现，不必在多个页面之间来回跳转，打开即能判断这是不是你正在找的作品。",
  },
  {
    icon: "ri-stack-line",
    title: "四种内容形态并行",
    desc: "漫画、小说、同人与番外本子分列展示，同一段剧情可以按阅读偏好选择呈现方式，条目之间注明差异与适配场景。",
  },
  {
    icon: "ri-filter-3-line",
    title: "标签筛选与卷册切换",
    desc: "同人区可按题材标签过滤，剧情区可按卷册切换查看章节摘要，筛选只作用于本页已有内容，结果即时反馈。",
  },
  {
    icon: "ri-calendar-check-line",
    title: "更新动态与追更提示",
    desc: "以时间线记录章节、同人与番外的更新节奏，标注内容形态与状态，方便追更读者快速判断哪一部分值得优先查看。",
  },
];

export const overviewHighlights = [
  { label: "题材基调", value: "家庭 · 成长 · 治愈" },
  { label: "叙事视角", value: "多人物分视角" },
  { label: "主要场景", value: "老城长街 · 旧琴房" },
  { label: "适读人群", value: "剧情向 · 同人向读者" },
];

export const characters = [
  {
    name: "苏晚",
    role: "岳母 · 故事核心",
    age: "32 岁",
    accent: "primary",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20minimal%20painterly%20portrait%20study%20of%20a%20calm%20young%20woman%20silhouette%20in%20profile%2C%20warm%20terracotta%20and%20cream%20tones%2C%20soft%20grain%20texture%2C%20abstract%20featureless%20artistic%20rendering%2C%20no%20text&width=400&height=400&seq=char-suwan-01&orientation=squarish",
    desc: "曾是小有名气的钢琴教师，因家庭变故提前离开舞台。外表温婉从容，遇到认定的事却格外坚持。她的重新出发，是整部作品的情绪主轴。",
    tags: ["钢琴教师", "外柔内刚", "故事核心"],
  },
  {
    name: "陆则言",
    role: "女婿 · 建筑设计师",
    age: "29 岁",
    accent: "secondary",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20minimal%20painterly%20portrait%20study%20of%20a%20quiet%20young%20man%20silhouette%20in%20profile%2C%20muted%20sage%20green%20and%20warm%20beige%20tones%2C%20soft%20grain%20texture%2C%20abstract%20featureless%20artistic%20rendering%2C%20no%20text&width=400&height=400&seq=char-luzeyan-01&orientation=squarish",
    desc: "话不多、做事细，习惯用行动代替表达。工作常年与图纸和工地打交道，是家里沉默却可靠的那一个，也是多段情节的观察者视角。",
    tags: ["设计师", "沉默可靠", "行动派"],
  },
  {
    name: "陆知夏",
    role: "女儿 · 插画师",
    age: "27 岁",
    accent: "accent",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20minimal%20painterly%20portrait%20study%20of%20a%20lively%20young%20woman%20silhouette%20in%20profile%2C%20warm%20ochre%20and%20soft%20cream%20tones%2C%20soft%20grain%20texture%2C%20abstract%20featureless%20artistic%20rendering%2C%20no%20text&width=400&height=400&seq=char-luzhixia-01&orientation=squarish",
    desc: "常年在外采风的插画师，是家里负责打破沉默的人。她的远行与归来，牵动着长街小院里每一次关系的松动与修补。",
    tags: ["插画师", "开朗", "牵线人"],
  },
  {
    name: "陈素心",
    role: "挚友 · 书店店主",
    age: "34 岁",
    accent: "primary",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20minimal%20painterly%20portrait%20study%20of%20a%20warm%20smiling%20woman%20silhouette%2C%20muted%20brick%20red%20and%20beige%20tones%2C%20soft%20grain%20texture%2C%20abstract%20featureless%20artistic%20rendering%2C%20no%20text&width=400&height=400&seq=char-chensuxin-01&orientation=squarish",
    desc: "在长街开了一间旧书店，是苏晚最信任的朋友。凡事爱张罗、爱出头，常常是推动剧情往前走的关键人物。",
    tags: ["书店店主", "热心", "剧情推动"],
  },
  {
    name: "周叙",
    role: "同部门好友 · 结构工程师",
    age: "30 岁",
    accent: "secondary",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20minimal%20painterly%20portrait%20study%20of%20an%20easygoing%20young%20man%20silhouette%2C%20muted%20olive%20and%20sand%20tones%2C%20soft%20grain%20texture%2C%20abstract%20featureless%20artistic%20rendering%2C%20no%20text&width=400&height=400&seq=char-zhouxu-01&orientation=squarish",
    desc: "则言的同事兼好友，性格直率爱开玩笑。作为旁观者，他常常一语点破当事人自己想不明白的心事。",
    tags: ["工程师", "直率", "旁观者"],
  },
  {
    name: "沈伯",
    role: "老邻居 · 退休教师",
    age: "66 岁",
    accent: "accent",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20minimal%20painterly%20portrait%20study%20of%20an%20elderly%20gentleman%20silhouette%2C%20warm%20ochre%20and%20faded%20brown%20tones%2C%20soft%20grain%20texture%2C%20abstract%20featureless%20artistic%20rendering%2C%20no%20text&width=400&height=400&seq=char-shenbo-01&orientation=squarish",
    desc: "在长街住了几十年，看着小院一代代人长大。他的回忆段落，补全了苏晚一家此前的经历与老城区的旧时光。",
    tags: ["退休教师", "见证者", "回忆线"],
  },
];

export const storyVolumes = [
  {
    id: "v1",
    name: "卷一 · 旧琴房",
    range: "第 1 - 8 章",
    status: "已完结",
    intro:
      "苏晚搬回老城长街的小院，与女儿、女婿同住。一组被闲置多年的旧琴，让尘封的往事一点点回到台面上来。",
    chapters: [
      { no: "第 1 章", title: "回到长街", summary: "苏晚带着两只旧行李箱回到小院，重新面对熟悉的门牌与陌生的安静。" },
      { no: "第 2 章", title: "落灰的琴键", summary: "打开储物间，她发现了从前常用的立式钢琴，琴盖上积着一层薄灰。" },
      { no: "第 3 章", title: "两把椅子的晚饭", summary: "知夏临时出差，晚饭桌上只剩苏晚与则言，两个人都不太习惯开口。" },
    ],
  },
  {
    id: "v2",
    name: "卷二 · 雨季来客",
    range: "第 9 - 18 章",
    status: "已完结",
    intro:
      "连绵的雨季里，小院住进一位临时借住的房客，几件被刻意回避的旧事在同一个屋檐下被重新提起。",
    chapters: [
      { no: "第 9 章", title: "漏水的那晚", summary: "老房子屋顶渗水，三个人半夜一起爬上阁楼，第一次真正聊起各自的近况。" },
      { no: "第 10 章", title: "借住的房客", summary: "陈素心介绍来一位短期房客，小院的空间与关系都因此发生了变化。" },
      { no: "第 11 章", title: "雨停了以后", summary: "雨季结束，一些原本说不出口的话，终于被轻轻放下了。" },
    ],
  },
  {
    id: "v3",
    name: "卷三 · 长街灯火",
    range: "第 19 - 30 章",
    status: "连载中",
    intro:
      "苏晚决定重开琴房教室，从零开始招生、整理琴谱。长街的灯火一间间亮起来，故事也进入最密集的推进阶段。",
    chapters: [
      { no: "第 19 章", title: "第一张招生单", summary: "苏晚在书店门口贴出第一张手写招生单，忐忑又认真。" },
      { no: "第 20 章", title: "第一个学生", summary: "一个总弹错音的孩子成为她重开琴房后的第一位学生。" },
      { no: "第 21 章", title: "长街的灯", summary: "琴房教室的灯每晚亮到很晚，长街的邻居们开始对这扇窗有了期待。" },
    ],
  },
  {
    id: "v4",
    name: "卷四 · 归途",
    range: "第 31 - 42 章",
    status: "即将上线",
    intro:
      "知夏结束长期采风回到长街，一家人重新凑齐。不同的人生选择摆到各自面前，这一卷要回答的是：他们各自想去哪里。",
    chapters: [
      { no: "第 31 章", title: "带回的画稿", summary: "知夏带回厚厚一叠采风画稿，里面藏着一个她一直没说的决定。" },
      { no: "第 32 章", title: "三个人的晚饭", summary: "很久没坐满的餐桌重新坐了三个位置，气氛却比想象中更复杂。" },
      { no: "第 33 章", title: "琴房的新名字", summary: "苏晚给琴房教室挂上新的木牌，名字是三个人一起想出来的。" },
    ],
  },
];

export const fanWorks = [
  {
    title: "琴键上的旧夏天",
    author: "木子",
    type: "温柔日常",
    length: "短篇 · 约 6 千字",
    excerpt: "写苏晚重开琴房前的最后一个夏天，把音乐、蝉鸣和旧照片串成一段安静的回忆。",
    likes: 428,
    tags: ["治愈", "日常", "音乐"],
  },
  {
    title: "则言的一天",
    author: "阿柚",
    type: "男主视角",
    length: "中篇 · 约 1.8 万字",
    excerpt: "以陆则言的一天为线索，用极度克制的笔墨写一个不擅长表达的人如何照顾身边的人。",
    likes: 512,
    tags: ["视角补完", "克制", "群像"],
  },
  {
    title: "如果那天没有下雨",
    author: "白鹿",
    type: "平行时空",
    length: "中篇 · 约 2.2 万字",
    excerpt: "把卷二的雨夜作为分岔点，想像如果那晚谁都没有开口，故事会走向什么样安静的结局。",
    likes: 386,
    tags: ["平行时空", "if 线", "遗憾向"],
  },
  {
    title: "长街的猫",
    author: "芋圆",
    type: "治愈群像",
    length: "短篇 · 约 5 千字",
    excerpt: "从一只常年在长街游荡的橘猫视角，旁观小院里一年四季的灯火与人来人往。",
    likes: 297,
    tags: ["治愈", "动物视角", "四季"],
  },
  {
    title: "苏晚的二十岁",
    author: "南栀",
    type: "前传补完",
    length: "中篇 · 约 1.5 万字",
    excerpt: "回到故事开始之前，写二十岁的苏晚如何第一次站上舞台，也如何第一次选择离开。",
    likes: 465,
    tags: ["前传", "成长", "舞台"],
  },
  {
    title: "雨季之后",
    author: "青禾",
    type: "续写延展",
    length: "长篇连载 · 更新至第 9 节",
    excerpt: "接在卷二结尾之后，续写房客离开后小院的日常，试图把那些未尽的话继续讲完。",
    likes: 233,
    tags: ["续写", "连载", "日常"],
  },
];

export const fanWorkTags = ["全部", "治愈", "视角补完", "平行时空", "前传", "续写", "日常"];

export const doujinItems = [
  {
    title: "《旧琴房》番外短篇集",
    type: "短篇合集",
    status: "已完成",
    pages: "全 96 页",
    desc: "收录琴房相关支线，补完正篇中只出现一两次的场景与配角结局，共 7 个独立短篇。",
  },
  {
    title: "《长街四季》插画本",
    type: "插画集",
    status: "已完成",
    pages: "全 64 页",
    desc: "以春、夏、秋、冬为章节的长街风景插画集，附苏晚一家的四季日常小场景与设定草图。",
  },
  {
    title: "《人物设定资料集》",
    type: "设定集",
    status: "已完成",
    pages: "全 120 页",
    desc: "整理主要人物的外形、性格、服装与关系网，另含长街小院的平面示意与场景说明。",
  },
  {
    title: "《归途 · 后日谈》",
    type: "番外本",
    status: "筹备中",
    pages: "预计 80 页",
    desc: "接在卷四之后的温和小故事，聚焦三个人各自的新生活，预计随卷四更新节奏发布。",
  },
  {
    title: "《琴谱手账》别册",
    type: "周边别册",
    status: "已完成",
    pages: "全 48 页",
    desc: "以苏晚的琴谱笔记形式整理的别册，边角写满她给学生与自己的批注，是最贴近角色内心的一册。",
  },
];

export const resourceCategories = ["全部", "漫画", "小说", "同人", "本子", "番外"];

export const resourceItems = [
  {
    kicker: "正篇",
    title: "《年轻的岳母》漫画正篇",
    category: "漫画",
    desc: "以分格叙事呈现主线剧情的漫画版本，按卷分章编排，便于按章节顺序连续追更。",
    meta: "持续更新 · 按卷归档",
    tags: ["主线", "连续追更"],
  },
  {
    kicker: "读物",
    title: "文库版小说全文索引",
    category: "小说",
    desc: "同一剧情的小说版本，文字量更完整，情绪与内心描写更充分，适合喜欢细读的读者。",
    meta: "已整理前 42 章",
    tags: ["文字向", "内心描写"],
  },
  {
    kicker: "共创",
    title: "精选同人创作合集",
    category: "同人",
    desc: "汇总读者投稿中口碑较高的同人作品，按题材归类，每篇附作者与简介，方便按偏好挑读。",
    meta: "342 篇 · 每周更新",
    tags: ["多作者", "按题材"],
  },
  {
    kicker: "外传",
    title: "番外与支线小故事",
    category: "番外",
    desc: "收录正篇之外的支线内容，补完配角结局与日常片段，读起来轻松，可独立浏览。",
    meta: "收录 26 则",
    tags: ["配角补完", "独立可读"],
  },
  {
    kicker: "纸质",
    title: "同人本与设定资料入口",
    category: "本子",
    desc: "集中说明《旧琴房》番外集、插画本与设定资料集的内容构成，注明页数与状态，便于比对选择。",
    meta: "含 5 册条目信息",
    tags: ["设定集", "插画本"],
  },
  {
    kicker: "专题",
    title: "无翼鸟等热门专题页说明",
    category: "漫画",
    desc: "整理无翼鸟等常见专题入口所对应的内容范围与更新情况，帮助读者判断该从哪个专题开始。",
    meta: "专题说明 · 不含跳转",
    tags: ["专题入口", "内容范围"],
  },
  {
    kicker: "长线",
    title: "卷四《归途》更新预告",
    category: "小说",
    desc: "提前放出的卷四人物走向与结构说明，标注与前三卷的衔接点，方便追更读者提前做准备。",
    meta: "即将上线",
    tags: ["预告", "追更"],
  },
  {
    kicker: "共创",
    title: "同人续写与 if 线专区",
    category: "同人",
    desc: "专放脱离主线的续写、平行时空与 if 线创作，与正篇区分展示，避免阅读顺序混淆。",
    meta: "与正篇分开展示",
    tags: ["续写", "平行时空"],
  },
];

export const readingGuideSteps = [
  {
    step: "01",
    icon: "ri-compass-3-line",
    title: "先看速览与人物",
    desc: "从顶部的作品速览和人物档案入手，用几分钟了解题材、基调与主要人物关系，再决定要不要深入。",
  },
  {
    step: "02",
    icon: "ri-layout-masonry-line",
    title: "按形态挑内容",
    desc: "喜欢画面就看漫画正篇，偏爱文字就选小说索引。同一段剧情，选最合你阅读习惯的那种形态。",
  },
  {
    step: "03",
    icon: "ri-list-ordered",
    title: "用卷册定位章节",
    desc: "在剧情脉络区切换卷册，查看每一章的标题与摘要，快速锁定你想从哪一段开始连续的阅读。",
  },
  {
    step: "04",
    icon: "ri-filter-line",
    title: "用标签筛同人",
    desc: "同人区按题材标签过滤，本子区按类型浏览，筛选只作用于本页已列出的条目，随点随变。",
  },
];

export const updates = [
  {
    date: "10 月 10 日",
    type: "章节",
    tag: "连载",
    title: "卷三《长街灯火》更新至第 21 章「长街的灯」",
    desc: "琴房教室的灯每晚亮到很晚，长街邻居对这扇窗的期待成为本卷的转折段落。",
  },
  {
    date: "10 月 07 日",
    type: "同人",
    tag: "共创",
    title: "同人区新增 6 篇「治愈」标签作品",
    desc: "含《长街的猫》《琴键上的旧夏天》等短篇，均补齐作者简介与阅读时长。",
  },
  {
    date: "10 月 03 日",
    type: "番外",
    tag: "外传",
    title: "番外区收录第 26 则支线故事《沈伯的旧相册》",
    desc: "通过老邻居的回忆视角补完长街小院更早年份的往事，可独立浏览。",
  },
  {
    date: "09 月 28 日",
    type: "设定",
    tag: "资料",
    title: "人物设定资料集页数信息更新至 120 页",
    desc: "补充小院平面示意与场景说明章节，方便读者理解空间关系。",
  },
  {
    date: "09 月 22 日",
    type: "条目",
    tag: "收录",
    title: "资源入口新增「无翼鸟专题说明」条目",
    desc: "说明常见专题入口对应的内容范围与更新情况，供读者判断从何处开始浏览。",
  },
  {
    date: "09 月 15 日",
    type: "预告",
    tag: "追更",
    title: "卷四《归途》结构预告上线",
    desc: "公开三人各自的走向线索与与前三卷的衔接点，追更读者可提前规划阅读顺序。",
  },
];

export const faqs = [
  {
    q: "《年轻的岳母》主要讲的是什么？",
    a: "它以一位 32 岁、提前离开舞台的钢琴教师苏晚为主视角，讲她搬回老城长街的小院、与女儿和女婿同住之后，如何在旧琴房、书店与长街的日常里重新安排自己的生活。基调偏家庭与成长，节奏舒缓。",
  },
  {
    q: "漫画、小说、同人和本子之间有什么区别？",
    a: "漫画与小说是主线剧情的两种呈现形态，前者重分格画面，后者重文字与内心描写；同人是读者在主线之外创作的衍生作品；本子与番外则是支线与补完内容，篇幅更短、可独立阅读。",
  },
  {
    q: "「无翼鸟」在页面里代表什么？",
    a: "它属于常见专题入口的一个代称，页面中仅作为内容范围与更新情况的说明出现，用来帮助读者判断从哪个专题开始浏览，本身不含跳转，也不收集任何信息。",
  },
  {
    q: "章节应该按什么顺序读比较好？",
    a: "建议按卷次顺序阅读：卷一《旧琴房》到卷四《归途》依次展开。若只想快速了解人物，可以先看人物档案，再回到任意一卷切换章节摘要，不必严格从头开始。",
  },
  {
    q: "页面里的同人筛选会联网或提交内容吗？",
    a: "不会。所有筛选、卷册切换与展开操作都只作用于本页已经存在的条目，不连接任何接口，也不需要账号或提交任何信息，刷新页面后即恢复默认视图。",
  },
  {
    q: "更新动态里的时间与状态是固定的吗？",
    a: "页面中的更新记录为演示用的固定条目，用于说明更新节奏的呈现方式。真实更新时间与状态需以你后续自行维护的内容为准，本页不做实时同步。",
  },
];

export const hotTags = [
  { name: "治愈日常", count: 186 },
  { name: "视角补完", count: 142 },
  { name: "平行时空", count: 98 },
  { name: "前传补完", count: 76 },
  { name: "群像", count: 64 },
  { name: "续写延展", count: 51 },
  { name: "音乐场景", count: 43 },
];

export const discussions = [
  {
    title: "卷二的雨夜，是不是全书最重要的一次和解？",
    author: "读者 · 拾柒",
    replies: 82,
    tag: "剧情讨论",
    excerpt: "三个人爬上阁楼补漏的那晚，很多之前回避的话题都被摆了出来，你们觉得这一段是不是整部作品的情绪转折点？",
  },
  {
    title: "陆则言这个角色其实并不沉默，只是不会说",
    author: "读者 · 木木",
    replies: 57,
    tag: "人物分析",
    excerpt: "重读了他所有出场的段落，发现他做的每一件小事都在回应别人，只是从来不说出口，这种写法真的很克制。",
  },
  {
    title: "如果卷四让三个人各自离开长街，你能接受吗？",
    author: "读者 · 阿澈",
    replies: 63,
    tag: "走向预测",
    excerpt: "预告里说这一卷要回答他们各自想去哪里，我有点担心会是一个各奔东西的结局，你们觉得合适吗？",
  },
  {
    title: "分享：我整理的长街小院时间线",
    author: "读者 · 芋圆",
    replies: 41,
    tag: "考据整理",
    excerpt: "把四卷里有明确日期的段落全部按时间排了一遍，发现雨季和琴房开课其实只隔了不到两个月。",
  },
];